<script setup lang="ts">
const visible = ref(false)
</script>

<template>
  <span>
    <div class="fixed bottom-60 right-20 z-8 h-40 w-40 flex cursor-pointer items-center justify-center rounded-50% bg-white text-18 color-[--color-text-1] shadow-[0_2px_4px_0_rgba(0,0,0,0.06)] hover:color-[--color-brand-6]" @click="visible = true">
      <i class="icon-xianxinglianxikefu" />
    </div>
    <DialogPtContactDialog v-model:visible="visible" />
  </span>
</template>
